<template>
    <v-card class="mx-auto">
      <v-toolbar flat color="blue-grey" dark>
        <v-toolbar-title>Booking Summary</v-toolbar-title>
        <img src="/img/expand.png" height="20px" class="expandStyle">
      </v-toolbar>
      <v-card-text class="card-design">
        <v-col cols="12" class="mt-0 mb-0 pt-0 pb-0">
          <v-row no-gutters>
            <v-col cols="6" class="text-subtitle-1 font-weight-black deep-orange--text  text--laccent-3">Grand Total
            </v-col>
            <v-col cols="6" class="text-subtitle-1 font-weight-black deep-orange--text  text--laccent-3">
              {{ GetGrandBookingSummary().displayGrandTotalAmount }}</v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-0 mb-0 pt-0 pb-0">
          <v-row no-gutters>
            <v-col cols="6" class="text-subtitle-1 font-weight-black teal--text  text--darken-1">Deposit</v-col>
            <v-col cols="6" class="text-subtitle-1 font-weight-black teal--text  text--darken-1">
              {{ GetGrandBookingSummary().displayDepositAmount }}</v-col>
          </v-row>
        </v-col>
      </v-card-text>
  
      <v-card-actions>
        <v-btn depressed href="#paymentDetails" v-if="roomReserves.length !== 0 && GetActiveScreen() !== 'bookingDetail'" color="success" class="mx-auto" @click="onMakeBooking">
          Proceed to payment
        </v-btn>
      </v-card-actions>
    </v-card>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from 'moment';
  
  export default {
    data: () => ({
      reveal: false,
      timeoutId: null,
    }),
    methods: {
      formatDate(date) {
        return moment(date).format('dddd Do MMMM YYYY')
      },
      formatDateShort(date) {
        return moment(date).format('DD/MM/YYYY')
      },
      onMakeBooking: function () {
        this.$store.dispatch('setActiveScreen', 'bookingDetail');
      },
      onBooked: function () {
        this.$store.dispatch('setActiveScreen', 'addRoom');
      },
      removeRoom: function (room) {
        console.log(room, 'removeRoom methods');
        this.$store.dispatch('removeRoom', room);
      },
      setTimeoutEvent: function () {
  
        if (this.GetPropertyInformation() === null) {
          return;
        }
  
        this.timeoutId = setTimeout(() => {
          // let amounts = [];
          let payload = [];
          // let payload = {
          //   amounts: [],
          //   depositPercentage: this.GetPropertyInformation().bookingPolicy.depositAmount
          // };
  
          this.roomReserves.forEach((r) => {
            let amounts = r.services.map((item) => {
              return {amount: item.amount, isNightRate: false} 
            })
            // amounts.push(r.ratePlan.totalPrice);
            let dailyRates = r.ratePlan.priceList.map((item, idx) => 
          {
            return {amount: item.price, isNightRate: true}          
          });
            amounts.push(...dailyRates);
  
            let model = {
              amounts: amounts,
              depositPercentage: r.ratePlan.depositPercentage,
              depositPolicy: r.ratePlan.bookingPolicyType
            }
  
            payload.push(model);
  
          })
  
          this.$store.dispatch('getDepositAndGrandTotalMany', payload).then((data) => {
            this.$store.commit('setGrandBookingSummary', data);
          });
        }, 1000)
      }
    },
    computed: {
      ...mapGetters([
        'GetArrival',
        'GetDeparture',
        'GetGrandBookingSummary',
        'GetActiveScreen',
        'GetPropertyInformation',
        'GetRoomReserves']),
      ...mapGetters({
        GetBookingInfo: 'GetBookingInfo'
      }),
      roomReserves: function () {
        if (this.timeoutId !== null) {
          clearTimeout(this.timeoutId);
          this.setTimeoutEvent();
        } else {
          this.setTimeoutEvent();
        }
        return [...this.GetRoomReserves()];
      }
    }
  };
  </script>
  
  <style>
  .v-card--reveal {
    bottom: 0;
    opacity: 1 !important;
    position: absolute;
    width: 100%;
  }

  .card-design {
    padding: 10px 0px 0px 50px !important;
  }

  a {
    text-decoration: none;
  }

  .expandStyle {
    display: block;
    margin-left: auto;
    position: fixed;
    z-index: 100;
    left: 90%;
  }
  </style>